module.exports = __webpack_public_path__ + "img/christoffer.fcf6aee1.png";